<template>
    <div class="container">
        <div class="row" v-if="loading" style="margin-top: 30%">
            <div class="col-md-4 offset-md-4 col-xs-12 text-center">
                Loading <i class="fa fa-2x fa-spin fa-cog"></i>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-4 offset-md-4 col-xs-12">
                    <div style="margin-top: 30%">
                        <img :src="`${account.brand_logo_large}`" class="img-fluid" style="width: 100%" v-if="account && account.brand_logo_large" />
                        <img src="/Images/Merit-EHS.png" width="100%" class="img-fluid mb-3" v-else />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-3 col-xs-12">
                        <h3 class="pb-2 mt-3 mb-4 border-bottom"><i class="fa fa-envelope"></i> Reset Password</h3>

                        <!-- Not sure what to do with this -->
                        <div v-if="status">
                            <div class="alert alert-success">
                                {{ status }}
                            </div>
                        </div>

                        <div>
                            <div :class="{ 'form-group': true, 'has-error': errors.username }" class="row">
                                <label class="col-sm-3 col-form-label text-sm-right">Email Address:</label>
                                <div class="col-sm-9">
                                    <input type="email" v-model="username" class="form-control" placeholder="Enter Email Address (Required)" />
                                    <span v-if="errors.username" class="text-danger">
                                        <span v-for="error in errors.username">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <button class="btn btn-primary" @click="resetPassword" :disabled="saving">
                                <template v-if="saving">Sending Reset Link <i class="fa fa-spinner fa-spin"></i></template>
                                <template v-else>Send Password Reset Link</template>
                            </button>
                            <hr/>
                            <a href="/login">Back to Login</a>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                username: this.$route.query.username,
                loading: true,
                saving: false,
                status: null,
                errors: [],
                account: null,
            }
        },

        methods: {
            getPasswordReset(){
                //Get the password reset
                this.$http
                .get('password/email')
                .then(response => {
                    //Alert the user?
                    this.account = response.data.account;
                })
                .catch(error => {

                })
                .then(response => {
                    //SHow loading
                    this.loading = false;
                });
            },

            resetPassword: function() {
                this.saving = true;

                //Setup
                var payload = {username: this.username};

                //Add the ID
                if(this.account)
                {
                    payload['SmartBizClientId'] = this.account.SmartBizClientId;
                }

                this.$http
                .post('password/email', payload)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Email Sent');

                    this.status = response.data.status;

                    this.errors = [];
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data

                        this.status = null;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the stuff
            this.getPasswordReset();
        }
    }
</script>
